import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MdArrowForwardIos } from "react-icons/md";

function SidebarMenu(props) {
  const location = useLocation();
  const [menuList, setMenuList] = useState([]);

  useEffect(() => {
    let filteredMenuList = props.menulist
    for (let i in filteredMenuList) {
      if (filteredMenuList[i].route === "/") {
        filteredMenuList[i].ChildList = [];
        filteredMenuList[i].isExpand = !filteredMenuList[i].isExpand;
      } else if (location.pathname.indexOf(filteredMenuList[i].route) > -1 && filteredMenuList[i].route) {
        filteredMenuList[i].isExpand = !filteredMenuList[i].isExpand;
      } else {
        filteredMenuList[i].isExpand = false;
      }
    }

    setMenuList(filteredMenuList);
  }, [props.menulist, location.pathname]);

  const toggleMenu = (key) => {
    const updatedList = menuList.map((item, index) => ({
      ...item,
      isExpand: index === key ? !item.isExpand : false,
    }));
    setMenuList(updatedList);
  };

  const toggleSubMenu = (parentIndex, childIndex) => {
    const updatedList = [...menuList];
    updatedList[parentIndex].ChildList[childIndex].isExpand = !updatedList[parentIndex].ChildList[childIndex].isExpand;
    setMenuList(updatedList);
  };

  return (
    <div className="w-full h-full px-1 overflow-scroll custom-scrollbar">
      <nav className="font-thin tracking-wider">
        <NavLink
          to={'/'}
          className={`py-2 pl-4 mt-1 hover:text-white hover:bg-[#191818] border-b border-gray-100 flex items-center justify-between text-xs px-2 font-medium hover:shadow`}
        >
          Dashboard
        </NavLink>
        {menuList.map((prop, key) => (
          <div key={key}>
            <NavLink
              to={prop.ChildList && prop.ChildList.length > 0 ? "#" : prop.route}
              className={`py-2 mt-3 pl-4 flex items-center justify-between ${menuList.length - 1 !== key ? 'border-b' : ''} border-b border-gray-100 text-xs px-2 font-medium hover:shadow hover:text-white hover:bg-[#191818]`}
              onClick={() => toggleMenu(key)}
            >
              <span className="text-xs">{prop.name}</span>
              {prop.ChildList && prop.ChildList.length > 0 && (
                <span className={`float-right ${prop.isExpand ? "transform rotate-90" : ""}`}>
                  <MdArrowForwardIos className="text-xs" />
                </span>
              )}
            </NavLink>
            {prop.ChildList && prop.ChildList.length > 0 && prop.isExpand && (
              <div className="pl-2 text-xs">
                {prop.ChildList.map((sub, i) => (
                  <div key={`${key}-${i}`}>
                    <NavLink
                      to={sub.ChildList && sub.ChildList.length > 0 ? "#" : `${prop.route}${sub.route}`}
                      className={`py-2 mt-2 pl-4 flex items-center justify-between text-xs px-2 font-medium hover:shadow hover:text-white hover:bg-[#262525]`}
                      onClick={() => toggleSubMenu(key, i)}
                    >
                      <span className="ml-4 text-xs">{sub.name}</span>
                      {sub.ChildList && sub.ChildList.length > 0 && (
                        <span className={`float-right ${sub.isExpand ? "transform rotate-90" : ""}`}>
                          <MdArrowForwardIos className="text-xs" />
                        </span>
                      )}
                    </NavLink>
                    {sub.ChildList && sub.ChildList.length > 0 && sub.isExpand && (
                      <div className="pl-8 text-xs bg-gray-50">
                        {sub.ChildList.map((sub2, j) => (
                          <NavLink
                            key={`${key}-${i}-${j}`}
                            to={`${prop.route}${sub.route}${sub2.route}`}
                            className="py-2 mt-1 pl-4 flex items-center justify-between text-xs px-2 font-medium hover:shadow hover:text-white hover:bg-[#4e4e4e]"
                          >
                            {sub2.name}
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
}

export default SidebarMenu;
